import React from "react";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";
import AdminDataFinancialRoutes from "./AdminDataFinancialRoutes";

const AdminDataFinancialScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Import Data Financial",
      page: "Import Data Financial Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminDataFinancialRoutes />
      </Track>
    </div>
  );
};

export default AdminDataFinancialScreen;
